import * as Types from './types';
export function show(show) {
    var action = {
        type: Types.SHOW_LOADER,
        show: show,
    };
    return action;
}
